import '../neb-button';

import { LitElement, html, css } from 'lit';

import { baseStyles } from '../../../../neb-styles/neb-styles';
import {
  CSS_COLOR_HIGHLIGHT,
  CSS_FONT_WEIGHT_BOLD,
  CSS_FONT_SIZE_HEADER,
  CSS_SPACING,
} from '../../../../neb-styles/neb-variables';

import '../inputs/neb-textfield';

export const ELEMENTS = {
  createAccountLink: { id: 'create-account' },
  emailInput: { id: 'input-email' },
  forgotPasswordLink: { id: 'forgot-password' },
  loginButton: { id: 'button-login' },
  passwordInput: { id: 'input-password' },
  errorText: { id: 'error-text' },
  inputContainer: { id: 'input-container' },
};

class NebBookingLoginForm extends LitElement {
  static get properties() {
    return {
      errorText: String,
      email: String,
      layout: {
        type: String,
        reflect: true,
      },
      password: String,
      emailFromInvite: String,
    };
  }

  static get styles() {
    return [
      baseStyles,
      css`
        :host {
          display: flex;
          flex-direction: column;
        }

        .login-header {
          color: ${CSS_COLOR_HIGHLIGHT};
          font-size: ${CSS_FONT_SIZE_HEADER};
          font-weight: ${CSS_FONT_WEIGHT_BOLD};
        }

        :host([layout='small']) .login-header {
          padding-top: 30px;
        }

        .container-input {
          margin: ${CSS_SPACING} 0;
          display: grid;
        }

        .container-email {
          margin-bottom: 10px;
        }

        .container-login {
          display: flex;
          align-items: center;
        }

        .link-forgot-password {
          color: ${CSS_COLOR_HIGHLIGHT};
          cursor: pointer;
          margin-left: ${CSS_SPACING};
          text-decoration: underline;
        }

        .link-create-account {
          color: ${CSS_COLOR_HIGHLIGHT};
          cursor: pointer;
          text-decoration: underline;
        }

        .spacer {
          height: 10px;
        }

        .spacer-bottom {
          height: 60px;
        }

        .error {
          color: red;
        }

        .textfield-input {
          display: flex;
          width: 100%;
        }
      `,
    ];
  }

  constructor() {
    super();

    this.__initState();
    this.__initHandlers();
  }

  __initState() {
    this.email = '';
    this.password = '';
    this.emailFromInvite = '';

    this.onLogin = () => {};

    this.onForgotPassword = () => {};

    this.onCreateAccount = () => {};
  }

  __initHandlers() {
    this.__handlers = {
      change: e => this.onChange(e.name, e.value),
      login: (_user, _pw) => this.onLogin(this.__email, this.__password),
      forgotPassword: () => this.onForgotPassword(),
      createAccount: () => this.onCreateAccount(),
      keyPressed: e => {
        if (e.key === 'Enter') {
          this.__handlers.login();
        }
      },
    };
  }

  __isLoginButtonDisabled() {
    return !(this.email && this.password);
  }

  firstUpdated() {
    this.__elements = {
      emailInput: this.shadowRoot.getElementById(ELEMENTS.emailInput.id),
      passwordInput: this.shadowRoot.getElementById(ELEMENTS.passwordInput.id),
    };
  }

  update(changedProps) {
    if (changedProps.has('emailFromInvite') && this.emailFromInvite) {
      this.__email = this.emailFromInvite;
    }

    super.update(changedProps);
  }

  __renderEmail() {
    return html`
      <div class="container-email">
        <neb-textfield
          id="${ELEMENTS.emailInput.id}"
          class="textfield-input"
          inputMode="email"
          name="email"
          label="Email"
          .value="${this.emailFromInvite || this.__email}"
          ?disabled="${!!this.emailFromInvite}"
          .onChange="${this.__handlers.change}"
        ></neb-textfield>
      </div>
    `;
  }

  __renderPassword() {
    return html`
      <div class="container-password">
        <neb-textfield
          id="${ELEMENTS.passwordInput.id}"
          class="textfield-input"
          name="password"
          label="Password"
          type="password"
          .value="${this.__password}"
          .onChange="${this.__handlers.change}"
        ></neb-textfield>
      </div>
    `;
  }

  render() {
    return html`
      <div class="login-header">Already have an account? Log in</div>

      <div
        class="container-input"
        id="${ELEMENTS.inputContainer.id}"
        @keydown="${this.__handlers.keyPressed}"
      >
        ${this.__renderEmail()} ${this.__renderPassword()}
        <div class="loading-error-container">
          ${this.errorText
            ? html`
                <p id="${ELEMENTS.errorText.id}" class="error">
                  ${this.errorText}
                </p>
              `
            : ''}
        </div>
      </div>

      <div class="container-login">
        <neb-button
          id="${ELEMENTS.loginButton.id}"
          label="Login"
          @click="${this.__handlers.login}"
        ></neb-button>

        <div
          id="${ELEMENTS.forgotPasswordLink.id}"
          class="link-forgot-password"
          @click="${this.__handlers.forgotPassword}"
        >
          Forgot password?
        </div>
      </div>

      <div class="spacer-bottom"></div>

      <div class="container-create-account">
        <span>First time booking online?</span>

        <span
          id="${ELEMENTS.createAccountLink.id}"
          class="link-create-account"
          @click="${this.__handlers.createAccount}"
          >Create an account</span
        >
      </div>
    `;
  }
}

customElements.define('neb-booking-login-form', NebBookingLoginForm);
